<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 30%">
                <div class="modal-header">
                    <slot name="header">
                        <div>
                            <h3 class="form-header">Signature Verification <i>({{ carouselCurrentPage }} out of {{ payload.stocktake.length }} signed)</i></h3>
                        </div>
                        <button @click="closeModal()" class="red-close-button"
                            style="width: 30px !important">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body" style="padding-bottom: 20px; text-align: left;">
                    <slot name="body">
                        <div v-if="warning"
                            style="color: #E04F39; width: fit-content; margin: 0 auto; margin: 1em auto; display: flex; align-items: center;">
                            <i class="pi pi-exclamation-circle" style="font-size: 2em !important"></i>
                            <h4 style="margin: 0; font-weight: normal">{{ warning }}</h4>
                        </div>

                        <p style="margin-left: 20px;">Note: Closing this modal will only save signed stocktake entries.</p>

                        <p style="margin: 0; margin-left: 20px; color:red; text-align: center">Please use PIN if set.</p>
                        <form class="action-modal" style="padding-top: 0">
                            <div v-if="!noAuthRequired" class="form-section-container" style="grid-template-columns: 1fr; padding-left: 0px;">
                                <Carousel :key="carouselKey" :value="payload.stocktake" :numVisible="1" :numScroll="1" ref="carousel_signature" circular>
                                    <template #item="slotProps">
                                        <div class="rounded" style="width:100%">
                                            <span style="font-size: 1em;">Medication: <b>{{ slotProps.data.name }}</b></span><br/>
                                            <span style="font-size: 1em;">Expected: <b>{{ slotProps.data.expected }}</b></span><br/>
                                            <span style="font-size: 1em;">Actual Count: <b>{{ slotProps.data.count }}</b></span><br/>

                                            <br/>
                                            <div style="margin-top: 10px;display: grid; justify-content: space-around; margin: 0 auto;" 
                                                :style="(
                                                        (this.forceSingleSig === undefined ? true : (this.forceSingleSig ? false : true)) &&
                                                        (displayReason ? (reason ? true : false) : true) && 
                                                        !success2 && !signPrimarySignature &&
                                                        !loading2 && (
                                                                endpoint =='/stock-take-submit' && (
                                                                    (requiresDoubleSig(slotProps.data.tags)) && 
                                                                    ($store.state.user.role.permissions.includes('signature_primary') || $store.state.user.role.permissions.includes('signature_witness')) 
                                                                )
                                                            )) ? { gridTemplateColumns: '1fr 1fr', gridGap: '10px', width: '100%'} : {  }">
                                                <div style="display: grid; grid-gap: 10px;  width:370px" 
                                                    v-if="!loading1 && !slotProps.data.signatures.sig1.success">
                                                    <h4 style="margin: 0; padding-left: 15px;text-align: left">
                                                        Signature 1
                                                    </h4>
                                                    <input
                                                        v-on:keyup.enter="verifySig(1, { notes: payload.notes, stocktake: [slotProps.data] })"
                                                        :ref="'signature_username_1_' + slotProps.index"
                                                        type="text"
                                                        v-model="slotProps.data.signatures.sig1.name"
                                                        placeholder="Username..."
                                                    >
                                                    <input
                                                        v-on:keyup.enter="verifySig(1, { notes: payload.notes, stocktake: [slotProps.data] })"
                                                        ref="sig1CarouselPassword"
                                                        type="password"
                                                        v-model="slotProps.data.signatures.sig1.password"
                                                        :placeholder="slotProps.data.signatures.sig1.success ? 'Signed' : 'PIN/Password...'"
                                                        autocomplete="one-time-code"
                                                    >
                                                    <div class="green-button"
                                                        @click="verifySig(1, { notes: payload.notes, stocktake: [slotProps.data] })">
                                                        {{slotProps.data.signatures.sig1.success ? 'Signed' : 'Sign'}}
                                                    </div>
                                                </div>
                                                <div v-if="slotProps.data.signatures.sig1.success" style="display: flex; align-items: center;width: 100%;justify-content: center;height: 147px">
                                                    <h4 style="color: green; margin: 0; border: 2px solid green; padding: 5px 10px; border-radius: 5px">
                                                        {{ prescriber ? "Prescriber" : "Signature 1" }} signed.
                                                    </h4>
                                                </div>
                                                
                                                <div style="display: grid; grid-gap: 10px"
                                                    v-if="(
                                                        (this.forceSingleSig === undefined ? true : (this.forceSingleSig ? false : true)) &&
                                                        (displayReason ? (reason ? true : false) : true) && 
                                                        !slotProps.data.signatures.sig2.success && !signPrimarySignature &&
                                                        !loading2 && (
                                                                endpoint =='/stock-take-submit' && (
                                                                    (requiresDoubleSig(slotProps.data.tags)) && 
                                                                    ($store.state.user.role.permissions.includes('signature_primary') || $store.state.user.role.permissions.includes('signature_witness')) 
                                                                )
                                                            ))">
                                                    <h4 style="margin: 0; padding-left: 15px; text-align: left">
                                                        Signature 2
                                                    </h4> 
                                                    <input
                                                        v-on:keyup.enter="verifySig(2, { notes: payload.notes, stocktake: [slotProps.data] })"
                                                        :ref="'signature_username_2_' + slotProps.index"
                                                        type="text"
                                                        v-model="slotProps.data.signatures.sig2.name"
                                                        placeholder="Username..."
                                                    >
                                                    <input
                                                        v-on:keyup.enter="verifySig(2, { notes: payload.notes, stocktake: [slotProps.data] })"
                                                        ref="sig2CarouselPassword"
                                                        type="password"
                                                        v-model="slotProps.data.signatures.sig2.password"
                                                        :placeholder="slotProps.data.signatures.sig2.success ? 'Signed' : 'PIN/Password...'"
                                                        autocomplete="one-time-code"
                                                    >
                                                    <div class="green-button"
                                                        @click="verifySig(2, { notes: payload.notes, stocktake: [slotProps.data] })">
                                                        Sign
                                                    </div>
                                                </div>
                                                <div v-if="slotProps.data.signatures.sig2.success" style="display: flex; align-items: center;width: 100%;justify-content: center;height: 147px">
                                                    <h4 style="color: green; margin: 0; border: 2px solid green; padding: 5px 10px; border-radius: 5px">
                                                        Signature 2 signed.
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </Carousel>
                            </div>
                        </form>
                        
                    </slot>
                </div>
                
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px; padding-top: 0px" v-if="carouselCurrentPage == payload.stocktake.length">
                    <slot name="footer" style="display: flex;">
                        <div class="green-button" @click="closeModal()">Complete</div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {toRaw} from 'vue'
import { nextTick, ref } from 'vue';
import Carousel from 'primevue/carousel';
import { drugsRequireDoubleSig, tagsRequireDoubleSig } from '../../services/doubleSignature';

export default {
    props: [
        'close', 
        'endpoint', 
        'isSuccessful', 
        'payload', 
        'header', 
        'manual_loop', 
        'stocktake_items',
        'stock_items', 
        'dual', 
        'warning', 
        'prescriber', 
        'notes', 
        'witness', 
        'optional', 
        'saveContext', 
        'displaySaveContext', 
        'noAuthRequired', 
        'bulkAdminister', 
        'displayReason',
        'isStatus', 
        'forceSingleSig', 
        'isWarehouse'
    ],
    components: {
        Carousel
    },
    computed: {
        getNotes() {
            if (this.payload.notes) return this.payload.notes;
            return this.verification.notes;
        },
        dualForMeds() {
            if (this.payload?.length >= 1) return this.payload.some(item => item.has_scheduled_items)
            if (this.payload.has_scheduled_items) return this.payload.has_scheduled_items;
            // payload can be drugs (everything), or stock_items (adjustmentmodal), or, ?? (newstocktake)
            let payloadDrugs = null
            if (this.payload.drugs != null) {
                payloadDrugs = toRaw(this.payload.drugs)
            }
            else if (this.payload.stocktake != null) {
                payloadDrugs = toRaw(this.payload.stocktake)
            }
            else if (this.payload.stock_items != null) {
                payloadDrugs = toRaw(this.payload.stock_items)
            }

            const facility = toRaw(this.$store.getters.getCurrentLocation)?.facility
            return drugsRequireDoubleSig(payloadDrugs, facility)
        }
    },
    data() {
        return {
            submitLoading: false,
            errMessage: '',
            errMessage2: '',
            witnessName: '',
            witnessRole: '',
            witnessRefNumber: '',
            toSubmit: this.payload,
            verification: {
                notes: '',
            },
            discardRemaining: false,
            singleSig: false,
            sigToken1: '',
            signature_1: '',
            sigToken2: '',
            signature_2: '',
            loading1: false,
            loading2: false,
            sig1: {
                name: '',
                password: '',
                company_id: this.$store.state.company.uuid,
            },
            success1: false,
            sig2: {
                name: '',
                password: '',
                company_id: this.$store.state.company.uuid,
            },
            success2: false,
            payloads:null,
            payloadsIndex: 0,
            reason:'',
            signPrimarySignature: false,
            cachedResults: {},
            carouselKey: 0,
            carouselCurrentPage: 0,
        }
    },
    methods: {
        requiresDoubleSig(tags) {
            const facility = toRaw(this.$store.getters.getCurrentLocation)?.facility
            return tagsRequireDoubleSig(tags, facility)
        },
        noAuthSignature(){
            axios.post('/account-signature', {}, this.$store.state.header).then(res=>{
                console.log('this is the account sig res', res.data);
                this.signature_1 = res.data.uuid;
                this.success1 = true;
                this.submitAction();
            }).catch(err=>{
                console.log('this is the error for account sig request', err.response.data);
            })
        },
        closeModal() {
            console.log('hitting this closemodal function signaturemodal')
            this.$emit('close', true);
            this.$emit('isSuccessful', true);
        },
        submitSingleStocktake(stocktakePayload) {
            console.log('stocktake payload to submit', stocktakePayload)
            this.submitLoading = true;
            let verification = {
                notes: '',
                signature_1: '',
                signature_2: '',
            }
            if ((
                this.$store.state.user.role.permissions.includes('signature_primary') || 
                this.$store.state.user.role.permissions.includes('signature_witness') == false ||  
                this.$store.state.user.role.permissions.includes('single_signature_primary')) && 
                stocktakePayload.stocktake[0].signatures.sig1.signature?.length > 0)
            {
                verification.signature_1 = stocktakePayload.stocktake[0].signatures.sig1.signature;
            }
            if ((this.dualForMeds || this.dual)  && 
                (this.$store.state.user.role.permissions.includes('signature_primary') || 
                this.$store.state.user.role.permissions.includes('signature_witness')) && 
                this.signature_2?.length > 0) 
            {
                console.log('this is a dual sig');
                if (this.optional) {
                    if (this.signature_2) {
                        verification.signature_2 = this.signature_2;
                        console.log('this is an optional sig2 signature signed');
                    }
                    console.log('this is an optional sig');
                } else {
                    verification.signature_2 = this.signature_2;
                    console.log('this is a dual sig that is not optional');
                }
                console.log('running through dual conditional', this.verification)
            }

            this.toSubmit = {...stocktakePayload};
            console.log('hitting at 465');
            if (!this.verification.notes) {
                delete this.verification.notes;
            } else {
                this.toSubmit.notes = this.verification.notes;
                delete this.verification.notes;
            }
            if (stocktakePayload.stocktake[0].signatures.sig1.signature &&  stocktakePayload.stocktake[0].signatures.sig1.signature.length > 0) {
                verification.signature_1 = stocktakePayload.stocktake[0].signatures.sig1.signature
            }
            if (stocktakePayload.stocktake[0].signatures.sig2.signature &&  stocktakePayload.stocktake[0].signatures.sig2.signature.length > 0) {
                verification.signature_2 = stocktakePayload.stocktake[0].signatures.sig2.signature
            }
            console.log('this is the toSubmit', this.toSubmit);

            this.toSubmit.verification = verification;
            
            if (this.toSubmit.notes) {
                this.toSubmit.notes = this.toSubmit.notes +`${this.reason && !this.endpoint.includes('effectiveness') ? ' \n Reason:' + this.reason : ''}`;
            }
            console.log('this is the toSubmit post concat', this.toSubmit.notes);
            
            axios.post(`${this.endpoint}`, this.toSubmit, this.header ? this.header : this.$store.state.header).then(async res => {
                console.log('action has been submitted', res);
                console.log('total stocktake payload length', this.payload.stocktake.length);
                console.log('carouselCurrentPage', this.carouselCurrentPage);
                if(this.carouselCurrentPage != this.payload.stocktake.length) {
                    const carousel = this.$refs.carousel_signature;
                    if (carousel) {
                        console.log('Moving carousel to next item', carousel);
                        carousel.step(-1);
                        this.focusInput();
                    }
                } else {
                    setTimeout(() => {
                        this.closeModal();
                    }, 300);
                }

                this.carouselCurrentPage ++;
                this.$store.dispatch('getRefreshToken');
                this.$emit('responseData', res.data);

            }).catch(err => {
                console.log('this is the error updated 389', err.response.data.message, err.response.data.errors);
                if(err.response.data && err.response.data.message && err.response.data.message.includes('ePrescribing service could not be contacted')){
                    this.errMessage = 'Unfortunately the prescription has not been submitted as the request has timed out. Feel free to try again or issue a paper prescription.';
                    this.errMessage2 = err.response.data.errors ? err.response.data.errors : ''
                } else{
                    this.errMessage = err.response.data;
                    this.errMessage2 = err.response.data.errors;
                }
                
                this.submitLoading = false;
                this.sig1 = {
                    name: '',
                    password: '',
                    company_id: this.$store.state.company.uuid,
                };
                this.sig2 = {
                    name: '',
                    password: '',
                    company_id: this.$store.state.company.uuid,
                };
                this.loading1 = false;
                this.success1 = false;
                this.success2 = false;

                this.singleSig = false;
            });
        },
        verifySig(signatureEntry, singleStocktakePayload) {
            console.log('verify payload', singleStocktakePayload)
            if (signatureEntry == 1 && singleStocktakePayload.stocktake[0].signatures.sig2.name != singleStocktakePayload.stocktake[0].signatures.sig1.name && !this.singleSig) {
                // this.loading1 = true;
                axios.post('/sign', singleStocktakePayload.stocktake[0].signatures.sig1, this.$store.state.header).then(res => {
                    console.log('this is the signature token', res.data);
                    this.$store.dispatch('getRefreshToken');
                    singleStocktakePayload.stocktake[0].signatures.sig1.token = res.data.access_token;
                    return res;
                }).then(() => {
                    axios.post('/signature', { signature_token: singleStocktakePayload.stocktake[0].signatures.sig1.token, type: '' }, this.$store.state.header).then(res => {
                        console.log('this is the signature id', res.data);
                        this.$store.dispatch('getRefreshToken');
                        singleStocktakePayload.stocktake[0].signatures.sig1.signature = res.data.uuid;
                        singleStocktakePayload.stocktake[0].signatures.sig1.success = true;
                        console.log('this is the signature id for sig 1', singleStocktakePayload.stocktake[0].signatures.sig1);
                        
                        if(this.requiresDoubleSig(singleStocktakePayload.stocktake[0].tags)){
                            if(singleStocktakePayload.stocktake[0].signatures.sig2.success && singleStocktakePayload.stocktake[0].signatures.sig1.success){
                                this.submitSingleStocktake(singleStocktakePayload)
                            }
                        } else{
                            if(singleStocktakePayload.stocktake[0].signatures.sig1.success){
                                this.submitSingleStocktake(singleStocktakePayload)
                            }
                        }
                    }).catch((err) => {
                        this.errMessage = err.response.data;
                        this.errMessage2 = '';
                        this.submitLoading = false;
                        this.sig1 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading1 = false;
                        this.success1 = false;
                        this.success2 = false;
                        this.singleSig = false;
                    });
                }).catch((err) => {
                    console.log('this is the sig error', err);
                    this.errMessage =  err.response.data;
                    this.errMessage2 = '';
                    this.submitLoading = false;
                    singleStocktakePayload.stocktake[0].signatures.sig1 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                        success: false,
                    };
                    this.loading1 = false;
                    this.success1 = false;
                    this.success2 = false;
                    this.singleSig = false;
                });

            }
            
            if (signatureEntry == 2 && singleStocktakePayload.stocktake[0].signatures.sig2.name != singleStocktakePayload.stocktake[0].signatures.sig1.name && !this.singleSig) {
                this.loading2 = true;
                this.singleSig = false;
                axios.post('/sign', singleStocktakePayload.stocktake[0].signatures.sig2, this.$store.state.header).then(res => {
                    console.log('this is the signature token', res.data);
                    this.$store.dispatch('getRefreshToken');
                    singleStocktakePayload.stocktake[0].signatures.sig2.token = res.data.access_token; 
                    return res;
                }).then(() => {
                    axios.post('/signature', { signature_token: singleStocktakePayload.stocktake[0].signatures.sig2.token, type: 'Witness' }, this.$store.state.header).then(res => {
                        this.$store.dispatch('getRefreshToken');
                        singleStocktakePayload.stocktake[0].signatures.sig2.signature = res.data.uuid;
                        singleStocktakePayload.stocktake[0].signatures.sig2.success = true;
                        console.log('this is the signature id for sig 2', singleStocktakePayload.stocktake[0].signatures.sig2);
                        this.loading2 = false;
                        
                        if((this.dualForMeds || this.dual)){
                            if(singleStocktakePayload.stocktake[0].signatures.sig2.success && singleStocktakePayload.stocktake[0].signatures.sig1.success){
                                this.submitSingleStocktake(singleStocktakePayload)
                            }
                        } else{
                            if(singleStocktakePayload.stocktake[0].signatures.sig1.success){
                                this.submitSingleStocktake(singleStocktakePayload)
                            }
                        }
                    }).catch(err => {
                        this.errMessage = err?.response?.data;
                        this.errMessage2 = '';
                        this.submitLoading = false;
                        singleStocktakePayload.stocktake[0].signatures.sig2 = {
                            name: '',
                            password: '',
                            company_id: this.$store.state.company.uuid,
                        };
                        this.loading2 = false;
                        this.success2 = false;
                    });
                }).catch((err) => {
                    this.errMessage = err?.response?.data;
                    this.errMessage2 = '';
                    this.submitLoading = false;
                    singleStocktakePayload.stocktake[0].signatures.sig2 = {
                        name: '',
                        password: '',
                        company_id: this.$store.state.company.uuid,
                    };
                    this.loading2 = false;
                    this.success2 = false;
                });
            }
        },
        focusInput() {
            const nextInput = this.$refs[`signature_username_1_${this.carouselCurrentPage + 1}`];
            if(nextInput) {
                console.log('next input', nextInput)
                setTimeout(() => {
                    console.log('focusing input')
                    nextTick(() => { 
                        nextInput.focus() 
                });
                }, 300);
            } else {
                console.log('no input found')
            }
        },
    },
    mounted() {
        nextTick(() => {
            this.carouselKey ++;
            this.focusInput();
        });
    },
    watch: {
        signPrimarySignature(newVal) {
            if (newVal) {
                this.sig2.name = ''
                this.sig2.password = ''
            }
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

.p-carousel {
  width: 100%;
}

.p-carousel-container {
    justify-content: center;
}

.p-carousel-item {
  display: flex;
  justify-content: center;
  width: 75%
}

.p-carousel-items-content {
    overflow: hidden !important;
    width: 750px !important;
    max-width: 750px;
}

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}

.discard-checkbox{
    height: 1.5em;
    margin: 0;
    padding: 0;
}
.signborder {
    background: none !important;
    border: 1px solid #f3f4f4;
}
.singleSignature {
    flex-direction: row !important;
    margin-left: auto;
    margin-right: 20px;
    align-items: center !important;

    .calenderdatelabel {
        flex-direction: row !important;
        align-items: center !important;
    }
}
</style>